import React, {Component} from 'react';
import {connect} from 'react-redux';
import { startLevel, finalAnswer } from '../../store/actions'
import GameLayout from '../../styled/GameLayout'
import Container from '../../styled/Container';
import TextContainer from '../../styled/TextContainer';
import GameAreaLayout from '../../styled/GameAreaLayout';
import TitleContainer from "../../styled/TitleContainer";
import SuperButton from "../SuperButton";

export default
@connect(state => {
  return {
    level: state.game.level,
    answer: state.game.answer
  }
})
class Answer extends Component {
  render() {
    return (
      <GameLayout justifyContent={'center'}>
        <GameAreaLayout>
          <Container padding={'0 0 20px 0'}>
            <TitleContainer>Верно!</TitleContainer>
          </Container>
          <Container
            width={'410px'}
            padding={'0 0 40px 0'}
          >
            <TextContainer>{this.props.answer}</TextContainer>
          </Container>
          <Container padding={'0 0 45px 0'}>
            {this.props.last
              ? (<SuperButton
                  width={'280px'}
                  height={'50px'}
                  onClick={() => {this.props.dispatch(finalAnswer())}}
                >Узнать результат</SuperButton>)
              : (<SuperButton
                  width={'280px'}
                  height={'50px'}
                  onClick={() => {this.props.dispatch(startLevel(this.props.level))}}
                >Следующий вопрос</SuperButton>)
            }

          </Container>
        </GameAreaLayout>
      </GameLayout>
    );
  }
}
